import { useEffect, useState } from 'react';

/** Tema claro/escuro: põe/remove data-theme="light" no <html>. Padrão = escuro. */
export function useTheme() {
  const [isLight, setIsLight] = useState(() => localStorage.getItem('theme') === 'light');

  useEffect(() => {
    const root = document.documentElement;
    if (isLight) root.setAttribute('data-theme', 'light');
    else root.removeAttribute('data-theme');
    localStorage.setItem('theme', isLight ? 'light' : 'dark');
  }, [isLight]);

  return { isLight, toggle: () => setIsLight(v => !v) };
}
